import { render, staticRenderFns } from "./copy-link.vue?vue&type=template&id=0f3d86eb&scoped=true"
import script from "./copy-link.vue?vue&type=script&lang=js"
export * from "./copy-link.vue?vue&type=script&lang=js"
import style0 from "./copy-link.vue?vue&type=style&index=0&id=0f3d86eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d86eb",
  null
  
)

export default component.exports